import { gql } from '@apollo/client'

import { SIMPLE_USER_FRAGMENT } from '../../../common/graphql/fragments'

const UPDATE_MENU_CURATION_TASK_SCRAPING_REVIEW_STATUS_MUTATION = gql`
  mutation updateMenuCurationTaskScrapingReviewStatusMutation(
    $id: ID!
    $action: ScrapingReviewActionType!
    $comment: String
  ) {
    updateMenuCurationTaskScrapingReviewStatus(
      id: $id
      action: $action
      comment: $comment
    ) {
      id
      taskStatus
      isAvailableForTierOne
      isAvailableForUnknownWordsCuration
      isAvailableForUnknownWordsQa
      isAvailableForCuration
      isAvailableForQa
      isAvailableForQc
      tags
      problemReason
      problemComment
      scrapingReviewComment
      scrapingReviewerComment
      scrapingClarificationComment
      isScrapingReviewDone

      lastManualUpdateBy {
        ...SimpleUserFragment
      }
    }
  }
  ${SIMPLE_USER_FRAGMENT}
`

export default UPDATE_MENU_CURATION_TASK_SCRAPING_REVIEW_STATUS_MUTATION
